define("@latermedia/ember-later-analytics/utils/state-types/error", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  /**
   * @module Utils
   */

  /**
   * @class ErrorUtil
   * @extends Utils
   */

  /**
   * Error State
   *
   * @property ERROR
   * @returns {string}
   */
  const ERROR = 'error';
  var _default = _exports.default = ERROR;
});